import { QueryParameter } from './../../../base-models/query-parameter';
import { BaseEntity } from './../../../base-models/base-entity';
import { BaseContainerService } from './base-container-service';
import { Injectable } from '@angular/core';
import { ModalService } from '../../../base-services/modal.service';
import { ModelData } from '../../../base-models/model-data';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ParentProperty } from '../../../base-models/parent-property';
import { Query } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalContainerService<T extends BaseEntity> extends BaseContainerService<T> {

  constructor(protected modalService: ModalService,
    protected ngbModalService: NgbModal) { 
    super();
  }

  random: number = Math.random();

  ShowList(){

  }

  ShowUpdate(){
    
  }

  AddItem(modelData: ModelData, parentProperty: ParentProperty = null, parameters: QueryParameter[] = null){
    this.modalService.ShowModal(-1, modelData, parentProperty, true, parameters)
      .result
        .then((item) => {
          //this.EmitItem(item);
        }, (reason) => {
          
        })
      //this.ngbModalService.open(modelData.UpdateComponent);
  }

  EditItem(modelData: ModelData, ID: number, parentProperty: ParentProperty = null, parameters: QueryParameter[] = null){
    this.modalService.ShowModal(ID, modelData, parentProperty, true, parameters)
      .result
        .then((item) =>{

        }, (reason) =>{
          
        })
  }
  // EditItem(modelData: ModelData, ID: number, Useridlk: number, parentProperty: ParentProperty = null, parameters: QueryParameter[] = null){
  //   this.modalService.ShowModal(ID, modelData, parentProperty, true, parameters)
  //     .result
  //       .then((item) =>{

  //       }, (reason) =>{
          
  //       })
  // }
}
